export const STATUS = {
  LATE: 'late',
  ABSENT: 'absent',
  IN_SHIFT: 'inshift',
  FINISHED: 'finished',
  UNDERTIME: 'undertime',
  ON_BREAK: 'onBreak'
};

export const mapStatus = (status, theme) => {
  switch (status) {
    case STATUS.ABSENT:
      return { slug: 'clockStatusAbsent', color: theme.colors.redNegative };
    case STATUS.LATE:
      return { slug: 'clockStatusLate', color: theme.colors.yellowPartially };
    case STATUS.IN_SHIFT:
      return { type: STATUS.IN_SHIFT, slug: 'clockStatusDuring', color: theme.colors.greenPositive };
    case STATUS.FINISHED:
      return { slug: 'clockStatusFinished', color: theme.colors.primary };
    case STATUS.UNDERTIME:
      return { slug: 'clockStatusUndertime', color: theme.colors.yellowPartially };
    case STATUS.ON_BREAK:
      return { slug: 'clockStatusOnBreak', color: theme.colors.sideBarBackground };
    default:
      return null;
  }
};

// Colors/labels for the Live View tab's attendance summary (Manage Booking → Live View tab:
// LiveViewPie/LiveViewHeatMap/LiveViewTimesheetStatuses), keyed by the flag names getAttendanceFlags
// returns (apps/figaro/src/scheduling/liveAttendance.js) — a different status set from STATUS/mapStatus
// above, which belongs to the standalone Live View route.
export const LiveViewStatsMap = {
  noStart: {
    color: '#99C4FF',
    label: 'noStart',
    descriptionSlug: 'liveViewDescriptionNotStarted'
  },
  lateAttendance: {
    color: '#FEB11F',
    label: 'lateAttendance',
    descriptionSlug: 'liveViewDescriptionLate'
  },
  clockedIn: {
    color: '#006AFF',
    label: 'clockedIn',
    descriptionSlug: 'liveViewDescriptionClockedIn'
  },
  checkedOut: {
    color: '#FF8833',
    label: 'checkedOut',
    descriptionSlug: 'liveViewDescriptionCheckedOut'
  },
  checkedIn: {
    color: '#10B07C',
    label: 'checkedIn',
    descriptionSlug: 'liveViewDescriptionCheckedIn'
  },
  clockedOut: {
    color: '#9E30E1',
    label: 'clockedOut',
    descriptionSlug: 'liveViewDescriptionClockedOut'
  },
  absent: {
    color: '#F24F63',
    label: 'absent',
    descriptionSlug: 'liveViewDescriptionAbsent'
  },
  onTime: {
    color: '#10B07C',
    label: 'onTime'
  },
  late: {
    color: '#FEB11F',
    label: 'arrivedLateClockIn'
  },
  undertime: {
    color: '#FEB11F',
    label: 'undertime'
  },
  overtime: {
    color: '#FEB11F',
    label: 'overtime'
  }
};

// The subset of Live View tab statuses relevant to the Event Index "Live View Status" filter — same
// statuses, in the same order, as LiveViewPie's legend: Not Started / Late / Clocked in / Checked in /
// Checked out / Clocked out / Absent. Keyed by the getAttendanceFlags flag name so filtering can check
// flags directly. requiresCheckInOut marks the two LiveViewPie only renders when showCheckInOutColumns
// is on, so consumers can gate them on exactly the same condition (see useProjectShifts.js).
export const LIVE_VIEW_FILTER_STATUSES = {
  notStarted: { statsMapKey: 'noStart', labelSlug: 'liveViewNoStart' },
  lateAttendance: { statsMapKey: 'lateAttendance', labelSlug: 'liveViewLateAttendance' },
  clockedIn: { statsMapKey: 'clockedIn', labelSlug: 'clockedIn' },
  checkedIn: { statsMapKey: 'checkedIn', labelSlug: 'checkedIn', requiresCheckInOut: true },
  checkedOut: { statsMapKey: 'checkedOut', labelSlug: 'checkedOut', requiresCheckInOut: true },
  clockedOut: { statsMapKey: 'clockedOut', labelSlug: 'clockedOut' },
  absent: { statsMapKey: 'absent', labelSlug: 'liveView_absent' }
};
